import { useI18n } from '../i18n';
import { Languages } from 'lucide-react';

export default function LanguageToggle() {
  const { lang, setLang } = useI18n();
  const nextLang = lang === 'en' ? 'zh' : 'en';
  const label = lang === 'en' ? 'English' : '中文';
  const nextLabel = lang === 'en' ? '中文' : 'English';

  return (
    <button
      onClick={() => setLang(nextLang)}
      className="w-full flex items-center justify-between px-3 py-2 rounded-lg text-xs font-medium transition-colors hover:bg-[var(--bg-hover)]"
      style={{ color: 'var(--text-secondary)' }}
      title={`Switch to ${nextLabel}`}
    >
      <div className="flex items-center gap-2">
        <Languages size={15} />
        <span>{label}</span>
      </div>
      <span className="text-[10px] px-1.5 py-0.5 rounded-full"
        style={{ backgroundColor: 'var(--bg-hover)', color: 'var(--text-muted)' }}>
        {nextLabel}
      </span>
    </button>
  );
}
